export enum EVerificationStatus {
    notVerified = 'not verified',
    verifying = 'verifying',
    verified = 'verified',
    error = 'error', // HTTP 500
}

export interface IConfirmPhone {
    phone: string,
    status: EVerificationStatus,
}

export type TPersonData = {
    editedFio: string,
    editedPhone: string,
    confirmedPhone: IConfirmPhone,
    isShowConfirm: boolean,
};

export const initialState: TPersonData = {
    editedFio: '',
    editedPhone: '',
    confirmedPhone: {
        phone: '',
        status: EVerificationStatus.notVerified,
    },
    isShowConfirm: false,
};

export interface IContactDetailsState {
    contactDetails: TPersonData,
}
